const constants = {
  ACTIONS: {
    SET_SERVICE_CATEGORIES: "SET_SERVICE_CATEGORIES",
    SET_SERVICE_TEMPLATES: "SET_SERVICE_TEMPLATES",
  } as { [key: string]: ServicesStore.eActionType },
};

export default constants;
